/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip, User, Popover, PopoverContent, PopoverTrigger } from '@nextui-org/react';
import { IconEdit, IconMapPin, IconPlus, IconSearch, IconTrash } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Constants, classNames, fromPhotos } from '../../../utils';
import { TeacherStudentSerivce, UsersService } from '../../../services';
import ModalCreateStudent from './create-student';
import Render from '../../../components/render';
import PaidAction from '../../../components/paid-action';

const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
  VIEW: 2,
  EDIT: 3,
  DELETE: 4,
}

const getStatusColor = (status) => {
  switch (status) {
    case Constants.USER.STATUS.ACTIVE:
      return 'text-green';
    case Constants.USER.STATUS.INACTIVE:
      return 'text-danger';
    case Constants.USER.STATUS.PENDING:
      return 'text-warning';
    default:
      return 'text-black';
  }
}

const getStatus = (status) => {
  switch (status) {
    case Constants.USER.STATUS.ACTIVE:
      return 'Activo';
    case Constants.USER.STATUS.INACTIVE:
      return 'Inactivo';
    case Constants.USER.STATUS.PENDING:
      return 'Pendiente';
    default:
      return 'Pendiente';
  }
}

const Students = () => {
  const [selectedItem, setSelectedItem] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { canResetFilter, data, filterBy, goToPage, isLoading, pagination, reload, deleteItem, user, download } = useFetchTable();

  const onSelectItem = (item, action) => {
    setSelectedItem(item);
    setModalAction(action);
  }


  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reload();
  }

  const isFreelanceTeacher = user?.level_id === Constants.USER.LEVELS.PROFESSOR && user?.school_id === null;

  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="4xl"
        isOpen={[MODAL_ACTION.CREATE, MODAL_ACTION.EDIT].includes(modalAction)}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.CREATE) return (
              <ModalCreateStudent
                onClose={onClose}
                onSuccess={() => closeModal(true)}
              />
            );
            if (modalAction === MODAL_ACTION.EDIT) return (
              <ModalCreateStudent
                user={selectedItem}
                onClose={onClose}
                onSuccess={() => closeModal(true)}
              />
            );
          }}
        </ModalContent>
      </Modal>

      <Modal
        size="sm"
        isOpen={modalAction === MODAL_ACTION.DELETE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.DELETE) return (
              <ModalDelete
                user={selectedItem}
                onClose={onClose}
                onDelete={() => {
                  deleteItem(selectedItem?.id);
                  closeModal(true);
                }}
              />
            );
          }}
        </ModalContent>
      </Modal>


      <Filters
        canResetFilter={canResetFilter}
        filterBy={filterBy}
        resetFilter={() => reload()}
      />

      <Table
        aria-label="Estudiantes Registrados"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex flex-row justify-between items-center gap-4">
            <h3 className="text-xl font-medium">Estudiantes Registrados</h3>
            <div className='flex gap-2'>
              <Render condition={isFreelanceTeacher}>
                <Button
                  className="pr-2 bg-green font-medium text-white"
                  endContent={<IconPlus color="white" />}
                  onPress={() => onSelectItem(null, MODAL_ACTION.CREATE)}
                >
                  Nuevo
                </Button>

                <PaidAction>
                  <Button
                    className="pr-2 bg-green font-medium text-white"
                    endContent={<IconPlus color="white" />}
                    onPress={() => download()}
                  >
                    Descargar
                  </Button>
                </PaidAction>
              </Render>
            </div>
          </div>
        }
      >
        <TableHeader>
          <TableColumn style={{ textWrap: 'wrap' }}>Nombre</TableColumn>
          <TableColumn style={{ textWrap: 'wrap' }}>DNI/C.I</TableColumn>
          <TableColumn style={{ textWrap: 'wrap' }}>Teléfono</TableColumn>
          <TableColumn style={{ textWrap: 'wrap' }}>Correo</TableColumn>
          <TableColumn style={{ textWrap: 'wrap' }}>Representantes</TableColumn>
          <TableColumn style={{ textWrap: 'wrap' }}>Estatus</TableColumn>
          <TableColumn align="end" />
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(user) => {
            const statusColor = getStatusColor(user.status);
            return (
              <TableRow key={user.id}>
                <TableCell>
                  <User
                    key={user?.photo}
                    avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(user.photo) : null }}
                    description={user.email}
                    name={user?.fullname}
                    classNames={{ description: 'text-foreground-500' }}
                  />
                </TableCell>
                <TableCell>{user.document_type?.name}{user.document}</TableCell>
                <TableCell>{user.phonecode?.name}-{user.phone}</TableCell>
                <TableCell>{user?.email}</TableCell>
                <TableCell>
                  <span
                    className="capitalize font-semibold text-sm text-secondary"
                  >
                    {user?.representatives?.map(x => x.parent.fullname).join(', ')}
                  </span>
                </TableCell>
                <TableCell>
                  <span className={classNames('font-medium', statusColor)}>
                    {getStatus(user.status)}
                  </span>
                </TableCell>
                <TableCell align="right">
                  <div className="relative flex justify-end items-center gap-2">
                    <Render condition={isFreelanceTeacher}>
                      <Tooltip content="Editar">
                        <IconEdit onClick={() => onSelectItem(user, MODAL_ACTION.EDIT)} />
                      </Tooltip>
                      <Tooltip content="Eliminar" color="danger">
                        <IconTrash className="text-danger" onClick={() => onSelectItem(user, MODAL_ACTION.DELETE)} />
                      </Tooltip>
                    </Render>
                  </div>
                </TableCell>
              </TableRow>
            )
          }}
        </TableBody>
      </Table>

      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const Filters = ({ canResetFilter, filterBy, resetFilter }) => {
  const initialFilter = {
    search: '',
    year: '',
    grade: '',
    section: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Input
        classNames={{
          base: 'w-full sm:max-w-[18rem]',
          inputWrapper: 'border-1 h-10',
        }}
        label="Buscar"
        labelPlacement="outside"
        placeholder="Nombre o cédula del estudiante"
        startContent={<IconSearch />}
        variant="bordered"
        radius="sm"
        value={form.search}
        onValueChange={v => onChange(v, 'search')}
      />

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}



const ModalDelete = ({ user, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar este estudiante?</p>
        <p className="text-center font-medium">{user.fullName}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    since: null,
    until: null,
    level: Constants.USER.LEVELS.PROFESSOR,
    school_id: ''
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const user = useSelector(state => state.user);

  const debounceTime = 500;
  const debounce = useRef();

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await TeacherStudentSerivce.student.getStudents({ ...filters, user_id: user.id });
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const deleteItem = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await UsersService.school.destroyStudent(id)
      toast.success('Usuario eliminado con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const download = async () => {
    setCanFetch(false);
    try {
      const response = await TeacherStudentSerivce.student.downloadEnrolledStudents({ ...filters, user_id: user.id });
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);


  return {
    canResetFilter: canResetFilter(),
    changePerPage,
    data,
    deleteItem,
    filters,
    filterBy,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
    user,
    download,
  }
}

export default Students;
